import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import type { Company } from "../lib/access";

interface Entry {
  id: number; action: string; target: string | null; created_at: string;
  profiles: { full_name: string | null } | null;
}

export function Audit({ company }: { company: Company }) {
  const [rows, setRows] = useState<Entry[] | null>(null);

  useEffect(() => {
    supabase.from("audit_log")
      .select("id,action,target,created_at,profiles:actor_id(full_name)")
      .eq("company_id", company.id)
      .order("created_at", { ascending: false })
      .limit(200)
      .then(({ data }) => setRows((data as unknown as Entry[]) ?? []));
  }, [company.id]);

  return (
    <>
      <header className="page-head">
        <h1>Activity</h1>
        <p className="muted">
          Everything done in this account, including anything Hauzisha support does on your
          behalf. This log cannot be edited or deleted by anyone.
        </p>
      </header>
      {rows === null ? <p className="muted">Loading…</p>
        : rows.length === 0 ? <div className="card"><p className="muted">Nothing recorded yet.</p></div>
        : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>When</th><th>Who</th><th>What</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td className="nowrap">{new Date(r.created_at).toLocaleString()}</td>
                    <td>{r.profiles?.full_name ?? "—"}</td>
                    <td><b>{r.action}</b>{r.target && <span className="sub">{r.target}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </>
  );
}
